import React, { useContext, useEffect, useState } from "react"
import "./interetCv.scss"
import { Box, Grid, Typography } from "@mui/material"
import { useLocation } from "react-router-dom"
import ThemeCvDto from "../../../../../api/models/cvTheme"
import cvskillService from "../../../../../api/services/cvskillService"
import CvSkillDto from "../../../../../api/models/cvskill"

interface InteretCvProps {
	theme: ThemeCvDto | null
}
function InteretCv({ theme }: InteretCvProps) {
	const [cvSkill, setCvSkill] = useState<CvSkillDto | null>(null)
	const [error, setError] = useState<string | null>(null)
	const [texts, setTexts] = useState<{ [key: string]: string }>({})

	const location = useLocation()

	useEffect(() => {
		const fetchData = async () => {
			try {
				const nav: any = location.state || {}
				const stateUserId = nav?.userId ?? null
				const stateCvSkillId = nav?.cvSkillId ?? null

				const lsUserId =
					Number(localStorage.getItem("selectedUserId")) || null
				const lsCvSkillId =
					Number(localStorage.getItem("selectedCvSkillId")) || null

				const effectiveCvSkillId = stateCvSkillId ?? lsCvSkillId
				const effectiveUserId = stateUserId ?? lsUserId

				console.log("[InteretCv] NAV STATE =", nav)
				console.log("[InteretCv] from LS =", { lsUserId, lsCvSkillId })
				console.log("[InteretCv] effective =", {
					effectiveUserId,
					effectiveCvSkillId,
				})

				let fetched: CvSkillDto | null = null

				if (effectiveCvSkillId) {
					console.log(
						"[InteretCv] fetch by cvSkillId =",
						effectiveCvSkillId,
					)
					fetched = await cvskillService.getCvSkillById(
						Number(effectiveCvSkillId),
					)
				} else if (effectiveUserId) {
					console.log(
						"[InteretCv] fetch by userId =",
						effectiveUserId,
					)
					fetched = await cvskillService.getCvSkillsByUserId(
						Number(effectiveUserId),
					)
				} else {
					setError("Aucun identifiant de CV / utilisateur fourni")
					return
				}

				console.log("[InteretCv] fetched cvSkill =", fetched)
				setCvSkill(fetched)
			} catch (e) {
				console.error("[InteretCv] fetch error:", e)
				setError("CV Skill non trouvé pour cet utilisateur")
			}
		}

		fetchData()
	}, [location.state])

	useEffect(() => {
		if (cvSkill?.poleInterets) {
			// Start empty so the placeholder isn't printed as real content
			const initialTexts = cvSkill.poleInterets.reduce(
				(acc, curr) => {
					acc[curr.interet] = ""
					return acc
				},
				{} as { [key: string]: string },
			)

			setTexts(initialTexts)
		}
	}, [cvSkill?.poleInterets])

	const styleTextArea = {
		marginTop: "0px",
		marginBottom: "-2%",
		width: "450px",
		height: "44px",
		padding: "10px",
		fontSize: "12px",
		borderRadius: "0px",
		backgroundColor: "transparent",
		border: "0px solid #ccc",
		resize: "none" as "none",
	}

	const styleBloc = {
		borderLeft: `2px solid ${theme?.colorBorder}`,
		borderTop: `2px solid ${theme?.colorBorder}`,
		padding: "20px",
		display: "inline-block",
		backgroundColor: `${theme?.intColorBackground}`,
		minHeight: "820px",
		backgroundImage: `url("${theme?.intImgBackground}")`,
		backgroundSize: "contain",
		backgroundRepeat: "no-repeat",
		backgroundPosition: "right",
		fontFamily: `"${theme?.fontFamily}", "sans-serif"`,
		paddingTop: "5%",
	}

	const styleText = {
		color: `${theme?.intColorText}`,
	}

	const styleLoisirsText = {
		color: `${theme?.intColorText}`,
		paddingTop: "5%",
	}

	const styleTextLosirs = {
		width: "450px",
		height: "44px",
		fontSize: "20px",
	}

	const handleTextChange = (
		e: React.ChangeEvent<HTMLTextAreaElement>,
		key: string,
	) => {
		setTexts(prev => ({
			...prev,
			[key]: e.target.value,
		}))
	}

	return (
		<Grid size={6} style={styleBloc}>
			{cvSkill?.poleInterets?.map((d, index) => (
				<Box key={d.interet} sx={{ mt: 2 }}>
					<h1 style={styleText}>{d.interet}</h1>
					<Typography style={styleText}>
						<textarea
							id={d.interet}
							style={styleTextArea}
							value={texts[d.interet] || ""}
							onChange={e => handleTextChange(e, d.interet)}
							placeholder="Exprimez-vous...!"
							className={
								(texts[d.interet] || "").trim() === ""
									? "empty-for-print"
									: "filled-for-print"
							}
						/>
					</Typography>
				</Box>
			))}

			<h1 style={styleLoisirsText}>Loisirs :</h1>
			<Box sx={{ mt: 2 }}>
				<Typography style={styleText}>
					<h5 style={styleTextLosirs}>
						{cvSkill?.poleLoisirInterets
							?.map(d => d.name)
							.filter(Boolean)
							.join(", ")}
					</h5>
				</Typography>
			</Box>
		</Grid>
	)
}

export default InteretCv
